// Verified in the owner's FOF Business Profile on 2026-09-21. Add destinations
// only after ownership verification; a social network homepage is not a profile.
const verified = { facebook: 'https://www.facebook.com/flytteogfragttilbuddk' };
export function verifiedSocialLink(network, value) {
  try {
    const url = new URL(value);
    if (url.username || url.password || url.search || url.hash) return null;
    return url.href.replace(/\/$/, '') === verified[network] ? verified[network] : null;
  } catch { return null; }
}
